export interface NotificationChannelPreferenceApiResource {
  channel: string;
  is_enabled: boolean;
}

export interface NotificationTypePreferenceApiResource {
  notification_type: string;
  is_mandatory: boolean;
  channels: NotificationChannelPreferenceApiResource[];
}

export interface NotificationPreferencesApiResource {
  preferences: NotificationTypePreferenceApiResource[];
}

export interface NotificationChannelPreference {
  channel: string;
  isEnabled: boolean;
}

export interface NotificationTypePreference {
  notificationType: string;
  isMandatory: boolean;
  channels: NotificationChannelPreference[];
}

export interface NotificationPreferences {
  preferences: NotificationTypePreference[];
}

export interface NotificationPreferenceUpdateItem {
  notificationType: string;
  channel: string;
  isEnabled: boolean;
}

export interface NotificationPreferenceUpdateItemApiPayload {
  notification_type: string;
  channel: string;
  is_enabled: boolean;
}

export interface NotificationPreferencesUpdateApiPayload {
  preferences: NotificationPreferenceUpdateItemApiPayload[];
}

export function mapApiResourceToNotificationPreferences(
  resource: NotificationPreferencesApiResource
): NotificationPreferences {
  return {
    preferences: resource.preferences.map(function mapType(type) {
      return {
        notificationType: type.notification_type,
        isMandatory: type.is_mandatory,
        channels: type.channels.map(function mapChannel(channel) {
          return { channel: channel.channel, isEnabled: channel.is_enabled };
        }),
      };
    }),
  };
}

export function mapUpdateItemsToApiPayload(
  items: NotificationPreferenceUpdateItem[]
): NotificationPreferencesUpdateApiPayload {
  return {
    preferences: items.map(function mapItem(item) {
      return {
        notification_type: item.notificationType,
        channel: item.channel,
        is_enabled: item.isEnabled,
      };
    }),
  };
}
